/**
 * Whether `pathname` should be treated as "on" `itemPath` — either exactly,
 * or on a nested route below it (e.g. `/patients` stays active on
 * `/patients/:id`). Matching on a path-segment boundary (a trailing `/`)
 * avoids false positives from routes that merely share a string prefix,
 * e.g. `/documents-and-materials` must NOT match `/documents`.
 */
export function isPathActive(pathname: string, itemPath: string): boolean {
  if (!itemPath) return false
  if (itemPath === '/') return pathname === '/'
  return pathname === itemPath || pathname.startsWith(`${itemPath}/`)
}
